import { Pipe, PipeTransform } from '@angular/core';
import { TableSortDirectionType, TableUISortModel } from '../models/table-sort.model';

/** `config` is an argument, not read from the service, so a later sort config re-renders it. */
@Pipe({ name: 'tableActiveSort' })
export class TableActiveSortPipe implements PipeTransform {
  transform(
    order: TableUISortModel | null,
    columnName: string | null,
    direction: TableSortDirectionType,
    config: Partial<TableUISortModel> | null,
  ): boolean {
    if (order) {
      return order.key === columnName && order.direction === direction;
    }

    if (config && config.key && config.direction) {
      return config.key === columnName && config.direction === direction;
    }

    return false;
  }
}
